import { render, staticRenderFns } from "./FileNotFormatUploaderState.vue?vue&type=template&id=a012738e&lang=pug"
import script from "./FileNotFormatUploaderState.vue?vue&type=script&lang=ts"
export * from "./FileNotFormatUploaderState.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports